/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userBusinessOffers

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userBusinessOffers.UserBusinessOffersApi
import features.userBusinessOffers.models.UserBusinessOffersModel
import features.userBusinessOffers.serializeUserBusinessOffersState



/**
 * Get a list of offers available to this user by specific business. [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("UserBusinessOffersApi")
class UserBusinessOffersApiJs {

    /**
     * Get a list of offers available to this user by specific business.
     */
    fun getUserBusinessOffers(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = UserBusinessOffersApi().getUserBusinessOffers(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<UserBusinessOffersModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeUserBusinessOffersState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        UserBusinessOffersApi().userBusinessOffersState.serializeUserBusinessOffersState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
